var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',[_c('booking-table',{attrs:{"preventDefault":"","items":_vm.bookings,"options":_vm.pagination,"excludeHeaders":[
                _vm.$constant.table.BOOKING_HEADER_KEY.saleAccount,
                _vm.$constant.table.BOOKING_HEADER_KEY.quantity
            ]},on:{"viewDetails":_vm.viewBookingDetails,"sort":_vm.emitBookingTableSort}})],1),_c('right-panel',{ref:"bookingDetailsPanel",attrs:{"hideBottom":"","title":_vm.$t('bookingList.bookingDetails.header')},scopedSlots:_vm._u([{key:"content",fn:function({ context }){return [_c('booking-details-view',{attrs:{"booking":context,"productTableExcludeHeaders":[
                    'description',
                    'productType',
                    'status',
                    'amount',
                    'total'
                ]}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }